import React from "react";
import Loading from "../../components/Loading/Loading";
import iconSpeaker from "./../../static/images/ico_speaker.svg";
import iconNoSpeaker from "./../../static/images/ico_no_speaker.svg";
import iconSwapCamera from "./../../static/images/ico_switch_camera.svg";
import Timer from "../../components/Timer";
import { history } from "../../helpers";
import { sessionActions, appointmentActions } from "../../store/actions";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { constants } from "../../Constants";
import { API_KEY, API_ROOT_URL } from "../../config";
import "./VideoSession.css";
import moment from "moment";
import ReactTooltip from "react-tooltip";

class VideoSession extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      streams: [],
      apiKey: API_KEY,
      sessionId: this.props.match.params.id,
      token: this.props.match.params.token,
      clientAudio: true,
      connection: "Other user has not joined",
      clientMic: true,
      cameraPosition: "front",
      clientScreen: true,
      clientVideo: true,
      counsellorConnected: false,
      timer: false,
      loading: true,
      speakerIcon: iconSpeaker,
      videoIcon: "fa-video",
      microphoneIcon: "fa-microphone",
      fullScreenIcon: "fa-expand-arrows-alt",
      swapCameraIcon: iconSwapCamera,
      note_id: null,
      deviceCounter: null,
      sessionConnected: false,
      showNote: false,
      session: null,
      publisher: null,
    };
    this.muteFunction = this.muteFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    let role = JSON.parse(localStorage.getItem("user")).role;
    if (role === 0) {
      this.props.fetchCallOptions();
    }
    this.setState({
      clientVideo: true, // or false, depending on initial state
      publisher: null,   // Reset publisher
    });
    this.initializeSession();
    const appointmentDetails = JSON.parse(localStorage.getItem('appointmentDetails'));
    if (appointmentDetails && appointmentDetails.date_time) {
      const sessionStartTime = new Date(appointmentDetails.date_time);
      this.calculateRemainingTime(sessionStartTime);
    }
  }


  componentWillUnmount() {
    if (this.state.session) {
      this.state.session.disconnect();
    }
    if (this.state.note !== undefined) {
      const { dispatch } = this.props;
      const appoitment_id = this.props.match.params.appointment;
      const user_id = this.props.user.user_id;
      const note = this.state.note;
      dispatch(sessionActions.CreateNote(note, user_id, appoitment_id));
    }
    this.setState({
      session: null,
      publisher: null,
    });
  }

  disconnectSession = () => {
    if (this.state.session) {
      this.state.session.disconnect();
    }
    if (this.state.publisher) {
      this.state.publisher.destroy();
    }
  }

  handleError = (error) => {
    if (error) {
      console.error('Error: ', error);
      alert(error.message);
    }
  }

  initializeSession = () => {
    if (!window.OT) {
      console.error('OpenTok library is not loaded');
      this.setState({ loading: false });
      return;
    }

    const session = window.OT.initSession(this.state.apiKey, this.state.sessionId);

    session.on('streamCreated', (event) => {
      session.subscribe(event.stream, 'subscriber', {
        insertMode: 'append',
        width: '100%',
        height: '100%'
      }, this.handleError);
    });

    const publisher = window.OT.initPublisher('publisher', {
      insertMode: 'append',
      width: '100%',
      height: '100%'
    }, (error) => {
      if (error) {
        console.error('Error initializing publisher: ', error);
      }
    });


    session.connect(this.state.token, (error) => {
      if (error) {
        this.handleError(error);
      } else {
        session.publish(publisher, this.handleError);
      }
    });
    this.setState({
      session: session,
      publisher: publisher,
      sessionConnected: true,
      loading: false
    });
  }
  handleEndCall = () => {
    const { appointmentOptions } = this.props;
    let filteredStatus = [];
    if (appointmentOptions && appointmentOptions.length > 0) {
      appointmentOptions.forEach((status) => {
        if (!(status == "Rescheduled/ cancelled")) {
          filteredStatus.push(status);
        }
      });
    }
    let role = JSON.parse(localStorage.getItem("user")).role;
    let counsellor_id = JSON.parse(localStorage.getItem("user")).counsellor_id;
    const options = filteredStatus
      ? filteredStatus.map((a, i) => {
        return `<option value=${i}>${a}</option>`;
      })
      : [];
    if (counsellor_id && role === 0) {
      Swal.fire({
        title: "Mark the session as completed or incomplete",
        input: "select",
        inputOptions: options,
        confirmButtonText: "Submit",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          var appointment_id = this.props.match.params.appointment;
          var session_id = window.location.pathname.split("/")[2];
          var e = Swal.getPopup().querySelector(".swal2-select");
          var inquiry = e.options[e.selectedIndex].value;
          const token = JSON.parse(localStorage.getItem("token"));
          const requestOptions = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({ appointment_id, inquiry }),
          };

          return fetch(
            `${API_ROOT_URL}/appointments/set_appointment_status/`,
            requestOptions
          )
            .then((response) => {
              if (!response.ok) {
                throw new Error(response.statusText);
              }
              return response.json();
            })
            .catch((error) => {
              Swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
        allowOutsideClick: () => !Swal.isLoading(),
      })
        .then((result) => {
          if (result.value !== undefined) {
            var e = Swal.getPopup().querySelector(".swal2-select"); //document.getElementById('statusdropdown');
            var inquiry = e.options[e.selectedIndex].value;
            if (inquiry === "0") {
              Swal.fire({
                title: "The session has been marked as incomplete successfully",
              });
            } else {
              Swal.fire({
                /* COUNSELLOR FEEDBACK POPUP STARTS */
                title: "Rate the audio and video quality of current session.",
                html: '<div class="star-rating__stars" id="starRatings"> <input class="star-rating__input" type="radio" name="rating" value="1" id="rating-1"> <label class="star-rating__label" for="rating-1" aria-label="One"></label> <input class="star-rating__input" type="radio" name="rating" value="2" id="rating-2"> <label class="star-rating__label" for="rating-2" aria-label="Two"></label> <input class="star-rating__input" type="radio" name="rating" value="3" id="rating-3"> <label class="star-rating__label" for="rating-3" aria-label="Three"></label> <input class="star-rating__input" type="radio" name="rating" value="4" id="rating-4"> <label class="star-rating__label" for="rating-4" aria-label="Four"></label> <input class="star-rating__input" type="radio" name="rating" value="5" id="rating-5"> <label class="star-rating__label" for="rating-5" aria-label="Five"></label> <div class="star-rating__focus"></div> </div>',
                confirmButtonText: "Submit",
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                if (result.value !== undefined) {
                  var checked = null;
                  var e = document.getElementById("starRatings");
                  var elements = e.getElementsByTagName("input");
                  for (var i = 0; elements[i]; ++i) {
                    if (elements[i].checked) {
                      checked = elements[i].value;
                      break;
                    }
                  }

                  if (checked) {
                    var appoitment_id = this.props.match.params.appointment;
                    const rating = checked;
                    const token = JSON.parse(localStorage.getItem("token"));
                    const requestOptions = {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                      },
                      body: JSON.stringify({ appoitment_id, rating }),
                    };

                    return fetch(`${API_ROOT_URL}/rating/`, requestOptions)
                      .then((response) => {
                        if (!response.ok) {
                          Swal.fire({
                            text: "This session has already been rated.",
                          });
                        } else {
                          Swal.fire({
                            title: "Thankyou for your feedback",
                          });
                        }
                        return response.json();
                      })
                      .catch((error) => {
                        Swal.showValidationMessage("Unknown Error");
                      });
                  }
                } else {
                  Swal.fire({
                    title: "You have not provided feedback for this session",
                  });
                }
              });
            }
          } else {
            Swal.fire({
              title: "You have not marked the session",
            });
          }
        })
        .then(() => {
          localStorage.setItem("session_ended", true);

          navigator.getUserMedia =
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia;

          if (navigator.mediaDevices) {
            // if navigator.mediaDevices exists, use it
            console.log("IOS safari");
            navigator.mediaDevices
              .getUserMedia({ audio: true, video: true })
              .then(
                (res) => console.log(res),
                (err) => console.log(err)
              );
          } else {
            navigator.getUserMedia(
              { audio: true, video: true },
              function (stream) {
                // can also use getAudioTracks() or getVideoTracks()
                var tracks = stream.getTracks(); // if only one media track
                tracks.forEach(function (track) {
                  if (track.kind === "video") {
                    if (track.enabled) {
                      track.stop();
                      track.enabled = false;
                    }
                  }
                });
              },
              function (error) {
                console.log("getUserMedia() error", error);
              }
            );
          }
          history.replace("/home");
        });
    } else {
      this.disconnectSession();
      localStorage.setItem("session_ended", true);
      if (navigator.mediaDevices) {
        // if navigator.mediaDevices exists, use it
        console.log("IOS safari");
        navigator.mediaDevices.getUserMedia({ audio: true, video: true }).then(
          (res) => console.log(res),
          (err) => console.log(err)
        );
      } else {
        navigator.getUserMedia(
          { audio: true, video: true },
          function (stream) {
            // can also use getAudioTracks() or getVideoTracks()
            var track = stream.getTracks()[0]; // if only one media track
            var track1 = stream.getTracks()[1];
            // ...
            track.stop();
            track1.stop();
          },
          function (error) {
            console.log("getUserMedia() error", error);
          }
        );
      }
      history.replace("/home");
    }
  };

  handleChange(e) {
    const { value } = e.target;
    this.setState({
      note: value,
    });
  }
  handleSubmit = () => {
    const { dispatch } = this.props;
    const appoitment_id = this.props.match.params.appointment;
    const user_id = this.props.user.user_id;
    const note = this.state.note;
    dispatch(sessionActions.CreateNote(note, user_id, appoitment_id)).then(
      (res) => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          position: "center-right",
        });

        this.setState(
          {
            // note:''
          },
          () => {
            this.openModal();
          }
        );

        Toast.fire({
          type: "success",
          title: "Note successfully saved",
        });
      }
    );
  };

  componentWillUnmount() {
    if (this.state.session) {
      this.state.session.disconnect();
    }

    if (this.state.note !== undefined) {
      const { dispatch } = this.props;
      const appoitment_id = this.props.match.params.appointment;
      const user_id = this.props.user.user_id;
      const note = this.state.note;
      dispatch(sessionActions.CreateNote(note, user_id, appoitment_id));
    }
    // localStorage.removeItem('appointmentDetails');
  }

  openModal = () => {
    this.setState({
      showNote: !this.state.showNote,
    });
  };

  closeModal = () => {
    document.getElementById("myForm").style.visibility = "hidden";
    document.getElementById("myForm").style.opacity = 0;
    document.getElementById("myForm").style.transitionDelay = "0s";

    document.getElementById("pencilIcon").style.visibility = "visible";
  };

  cycleVideo = () => {
    var publisher = new window.OT.Publisher();
    this.meRefrence.otPublisher.state.publisher
      .cycleVideo()
      .catch(console.error);
  };

  fullScreenVideo = () => {
    const element = document.documentElement;
    var requestMethoda =
      element.requestFullScreen ||
      element.webkitRequestFullScreen ||
      element.mozRequestFullScreen ||
      element.msRequestFullScreen;
    var requestMethodb =
      document.exitFullscreen ||
      document.webkitExitFullscreen ||
      document.mozExitFullscreen ||
      document.msExitFullscreen;
    if (this.state.fullScreenIcon === "fa-expand-arrows-alt") {
      // Native full screen.
      requestMethoda.call(element);
    } else if (this.state.fullScreenIcon === "fa-compress-arrows-alt") {
      requestMethodb.call(document);
    } else if (typeof window.ActiveXObject !== "undefined") {
      // Older IE.
      // eslint-disable-next-line no-undef
      var wscript = new ActiveXObject("WScript.Shell");
      if (wscript !== null) {
        wscript.SendKeys("{F11}");
      }
    }
  };
  calculateRemainingTime = (sessionStartTime) => {
    this.timerInterval = setInterval(() => {
      const currentTime = moment();
      const elapsedTime = currentTime.diff(sessionStartTime, 'seconds');
      const remainingTime = 3600 - elapsedTime;
  
      if (remainingTime <= 0) {
        clearInterval(this.timerInterval);
        this.setState({ remainingTime: 0 });
      } else {
        this.setState({ remainingTime });
      }
    }, 1000);
  };

  render() {
    const user = JSON.parse(localStorage.getItem("user"));
    const appointmentDetails = JSON.parse(localStorage.getItem("appointmentDetails"));
    const role = user.role;
    const { whitelabel } = this.props;
    const displayName = appointmentDetails && (role === 1 ? appointmentDetails.counsellor_name : appointmentDetails.patient_name);
    const { remainingTime } = this.state;
    const formattedTime = remainingTime > 0
    ? moment.utc(remainingTime * 1000).format("mm:ss")
    : '00:00';
    
    const initials = displayName
      ? displayName
        .toString()
        .split(" ")
        .map((a) => a.charAt(0).toUpperCase())
        .join("") // Join initials
      : "";

    return (
      <React.Fragment>
        <div id="videos">
          {/* session timer and info */}
          <div className="sh-csc-dr-info">
            <div className="sh-csc-container">
              <div className="sh-csc-dr-left">
                <span className="sh-csc-title">{initials}</span>
              </div>
              <div className="sh-csc-dr-right">
                <span className="sh-csc-name">{displayName}</span>
               <span>{formattedTime}</span>
              </div>
            </div>
            <div className="sh-csc-dr-right">
              <span className="sh-csc-timer">
                {!this.state.counsellorConnected && role === 1 ? (
                  <p className="sh-video-gnrl-text">
                    Your{" "}
                    {whitelabel && whitelabel[0]
                      ? whitelabel[0].producer_role
                      : constants.COUNSELLOR}{" "}
                    has not joined. Please wait
                  </p>
                ) : null}
                {!this.state.counsellorConnected && role === 0 ? (
                  <p className="sh-video-gnrl-text">
                    Your{" "}
                    {whitelabel && whitelabel[0]
                      ? whitelabel[0].consumer_role
                      : constants.PATIENT}{" "}
                    has not joined. Please wait
                  </p>
                ) : null}
              </span>
            </div>
          </div>

          {/* Notes Screen */}
          <div
            className={`sh-video-notes ${this.state.showNote && "show-notes"}`}
          >
            <div className="sh-vh-inner">
              <div className="sh-vn-close-icon" onClick={this.openModal}></div>
              <div className="sh-vh-content">
                <div className="sh-vh-input">
                  <textarea
                    rows={10}
                    id="note_textarea"
                    className="sh-note-textarea"
                    name="text_area"
                    onChange={this.handleChange}
                    value={this.state.note}
                    placeholder="Add your notes here."
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        this.handleSubmit();
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>


          <div className="sh-csc-footer">
            <div className="sh-csc-footer-inner">

              {/* Tooltip for Edit Icon */}
              <ReactTooltip key="edit-tooltip" id="edit-tooltip" place="top" effect="solid">
                {constants.ADD_NOTES_TXT}
              </ReactTooltip>
              <div
                className="sh-csc-video-icon"
                onClick={this.openModal}
                id="pencilIcon"
                data-tip
                data-for="edit-tooltip"
              >
                <i
                  className="fas fa-pen"
                  onClick={this.openModal}
                  id="pencilIcon"
                />
              </div>

              {/* Tooltip for Mute/Unmute Microphone */}
              <ReactTooltip key="mute-mic-tooltip" id="mute-mic-tooltip" place="top" effect="solid">
                {this.state.clientMic ? constants.MUTE_MICROPHONE_TXT.OFF : constants.MUTE_MICROPHONE_TXT.ON}
              </ReactTooltip>
              <div
                className="sh-csc-video-icon"
                id="mute-mic"
                onClick={this.muteFunction}
                data-tip
                data-for="mute-mic-tooltip"
              >
                <i
                  className={`fas ${this.state.microphoneIcon}`}
                  id="mute-mic"
                  onClick={this.muteFunction}
                ></i>
              </div>

              {/* Tooltip for End Call */}
              <ReactTooltip key="end-call-tooltip" id="end-call-tooltip" place="top" effect="solid">
                {constants.END_CALL_TXT}
              </ReactTooltip>
              <div
                className="sh-csc-video-icon sh-bg-red"
                data-tip
                data-for="end-call-tooltip"
              >
                <i
                  className="fas fa-phone"
                  onClick={this.handleEndCall}>
                </i>
              </div>

              {/* Tooltip for Mute/Unmute Video */}
              <ReactTooltip key="mute-video-tooltip" id="mute-video-tooltip" place="top" effect="solid">
                {this.state.clientVideo ? constants.MUTE_VIDEO_TXT.OFF : constants.MUTE_VIDEO_TXT.ON}
              </ReactTooltip>
              <div
                className="sh-csc-video-icon"
                id="mute-video"
                onClick={this.muteFunction}
                data-tip
                data-for="mute-video-tooltip"
              >
                <i
                  className={`fas ${this.state.videoIcon}`}
                  id="mute-video"
                  onClick={this.muteFunction}
                ></i>
              </div>

              {/* Tooltip for Swap Camera (if more than 1 device) */}
              {this.state.deviceCounter > 1 && (
                <React.Fragment>
                  <ReactTooltip key="swap-camera-tooltip" id="swap-camera-tooltip" place="top" effect="solid">
                    {constants.SWAP_CAMERA_TXT}
                  </ReactTooltip>
                  <div
                    className="sh-csc-video-icon"
                    id="swap-camera"
                    onClick={this.cycleVideo}
                    data-tip
                    data-for="swap-camera-tooltip"
                  >
                    <i
                      className="fas fa-sync-alt"
                      id="swap-camera"
                      onClick={this.cycleVideo}
                    />
                  </div>
                </React.Fragment>
              )}

              {/* Tooltip for Full Screen */}
              <ReactTooltip key="full-screen-tooltip" id="full-screen-tooltip" place="top" effect="solid">
                {this.state.clientScreen ? constants.FULL_SCREEN_TXT.OFF : constants.FULL_SCREEN_TXT.ON}
              </ReactTooltip>
              <div
                className="sh-csc-video-icon"
                id="full-video"
                onClick={this.muteFunction}
                data-tip
                data-for="full-screen-tooltip"
              >
                <i
                  className={`fas ${this.state.fullScreenIcon}`}
                  id="full-video"
                  onClick={this.muteFunction}
                ></i>
              </div>
            </div>
          </div>
          <div id="subscriber" className="subscriber-video"></div>
          <div id="publisher" className="publisher-video"></div>
        </div>
        <div className="sh-video-session-screen">

        </div>
      </React.Fragment>
    );
  }

  // CUSTOM FUNCTIONS

  muteFunction(event) {
    const icon = event.target;
    switch (icon.id) {
      default:
        break;
      case "mute-video":
        if (this.state.clientVideo) {
          this.state.publisher.publishVideo(false, (error) => {
            if (error) {
              console.error('Error turning off video: ', error);
            } else {
              this.setState({
                videoIcon: "fa-video-slash",
                clientVideo: false,
              });
            }
          });
        } else {
          this.state.publisher.publishVideo(true, (error) => {
            if (error) {
              console.error('Error turning on video: ', error);
            } else {
              this.setState({
                videoIcon: "fa-video",
                clientVideo: true,
              });
            }
          });
        }
        break;
      case "mute-audio":
        if (this.state.clientAudio) {
          this.setState({
            speakerIcon: iconNoSpeaker,
            clientAudio: !this.state.clientAudio,
          });
        } else {
          this.setState({
            speakerIcon: iconSpeaker,
            clientAudio: !this.state.clientAudio,
          });
        }
        break;
      case "mute-mic":
        if (this.state.clientMic) {
          this.state.publisher.publishAudio(!this.state.clientMic);
          this.setState({
            microphoneIcon: "fa-microphone-slash",
            clientMic: !this.state.clientMic,
          });
        } else {
          this.state.publisher.publishAudio(!this.state.clientMic);
          this.setState({
            microphoneIcon: "fa-microphone",
            clientMic: !this.state.clientMic,
          });
        }
        break;
      case "full-video":
        if (this.state.clientScreen) {
          this.fullScreenVideo();
          this.setState({
            fullScreenIcon: "fa-compress-arrows-alt",
            clientScreen: !this.state.clientScreen,
          });
        } else {
          this.fullScreenVideo();
          this.setState({
            fullScreenIcon: "fa-expand-arrows-alt",
            clientScreen: !this.state.clientScreen,
          });
        }
        break;
    }
  }
}

function mapStateToProps(state) {
  const { session, auth, alert } = state;
  const { appointments } = state;
  const { appointmentOptions } = appointments;

  const { user } = auth;
  const { whitelabel } = state.whitelabel;
  return {
    user,
    alert,
    appointments,
    session,
    whitelabel,
    appointmentOptions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchCallOptions: () => {
      dispatch(appointmentActions.fetchCallStatus());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoSession);



// WEBPACK FOOTER //
// ./src/screens/VideoSession/index.js